import { computed, watch, type ComputedRef, type Ref } from 'vue';
import { storeToRefs } from 'pinia';
import type { MaterialV1 } from '@ilteducation/content-registry-types';
import type { Category } from '@ilteducation/content-ref-data-types/models/data-types';
import { useContentRefData } from '@ilteducation/content-ref-data';

// Grades and subjects have their own chip rows, so this leaves the rest (shortcuts etc).
const useMaterialCategories = (material: Ref<MaterialV1> | ComputedRef<MaterialV1>) => {
  const contentRefDataStore = useContentRefData();
  const { byId } = storeToRefs(contentRefDataStore);

  const categoryIds = computed<string[]>(() => material.value?.categories ?? []);

  watch(
    categoryIds,
    (ids) => {
      if (ids.length) {
        contentRefDataStore.loadByIds('categories', ids);
      }
    },
    { immediate: true },
  );

  const otherCategories = computed<Category[]>(() =>
    categoryIds.value
      .map((categoryId) => byId.value('categories', categoryId) as Category | undefined)
      .filter((category): category is Category => category !== undefined)
      .filter((category: Category) => category.kind !== 'grade' && category.kind !== 'subject'),
  );

  return { otherCategories };
};

export default useMaterialCategories;
